import { useState } from "react";
import CustomModel from "../../Utility/CustomModel";
import { toast } from "react-toastify";
import { handleTexttoTable } from "../../Utility/Algorithm";

export const AlgorithmModal = ({ editor, setOpen, open }) => {
  const [title, setTitle] = useState(null);

  const handleChange = (e) => {
    const { value } = e.target;
    if (value.trim()) {
      setTitle(value);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (title) {
      setOpen(false);
      const success = handleTexttoTable(editor, title);
      if (success) {
        toast.success("Text to Table Algorithm Converted");
      }
    }
  };
  return (
    <div className="w-fit h-fit">
      <CustomModel
        handleCancel={handleCancel}
        heading={"Algorithm Title"}
        width={"300px"}
        show={open}
      >
        <form
          onSubmit={(e) => handleSubmit(e)}
          className="w-full h-full flex flex-col gap-2 mt-5"
        >
          <label htmlFor="title">Title</label>
          <input
            value={title}
            onChange={(e) => handleChange(e)}
            className="outline-none border border-grey"
            name="title"
            type="text"
          />
          <div className="ml-auto">
            <div className="flex py-3 ml-auto gap-4">
              <button
                className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
                onClick={() => handleCancel()}
              >
                {" "}
                Cancel
              </button>
              <button
                className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </CustomModel>
    </div>
  );
};
